
/**
 * Représente les comparaisons
 */
export class Comparaisons {
    /**
     * Test vrai
     * @param obj
     */
    public static testVrai(obj: any): boolean {
        return obj === true || obj === 'True' || obj === 'true' || obj === '1' || obj === 1;
    }
}
